<template>
  <div id="app">
   <Header />
   <Lunbo />
    <PageMain/>
	<About/>
    <Bottom />
    <CeBian />
  </div>
</template>

<script>
import About from "@/components/PageMain/About";
import Header from '@/components/header2'
import Lunbo from '@/components/Lunbo'
import PageMain from '@/components/PageMain'
import Bottom from "@/components/PageMain/Bottom";
import CeBian from "@/components/CeBian";


export default {
  name: 'App',
  components: {
    Header,
    Lunbo,
    PageMain,
	About,
    Bottom,
    CeBian
  },
  
};
</script>

<style >

</style>
